var ExerciseWorkModule = (function () {
    function ExerciseWorkModule() {
    }
    return ExerciseWorkModule;
}());
export { ExerciseWorkModule };



// WEBPACK FOOTER //
// ./src/app/app-exercise-work/exercise-work.module.ts.pre-build-optimizer.js